<template>
  <div class="select-menus">
    <div
      class="select-menus.item"
      v-for="(item, index) in allMenus"
      :key="index"
    >
      <div class="select-menus.tab">
        <span>{{ item.type }}</span>
        <ul
          :class="[
            'menus' + index,
            { '+moreHeight': isMore && item.isShowBtn },
            {
              '+moreShortHeight':
                isMore && item.isShowBtn && item.type == '版权类型',
            },
          ]"
        >
          <!-- <li>全部</li> -->
          <li
            v-for="(tab, key) in item.lists"
            :key="key"
            @click="selectTabs(key, index, item)"
            ref="liId"
          >
            {{ tab.name }}
          </li>
        </ul>
        <button
          @click="showMore(index)"
          :class="{ '+moreIcon': isMore }"
          v-show="item.isShowBtn"
        >
          {{ moreText }}
        </button>
      </div>
    </div>
    <div class="select-menus.selected" v-if="chooseArr.length > 0">
      <h3>您已选择：</h3>
      <div>
        <a href="javascript:;" v-for="(item, index) in chooseArr" :key="index">
          <span>{{ item.name }}</span>
          <span @click="delSelected(item)"
            ><img src="../assets/close-menu.png" alt=""
          /></span>
        </a>
        <a href="javascript:;" @click="delAll">
          <span>全部清空</span>
          <span><img src="../assets/del-menu.png" alt="" /></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["allMenus"],
  data() {
    return {
      isMore: false,
      choose: {},
      chooseArr: [],
      moreText: "更多",
    };
  },
  watch: {
    choose: {
      handler(newVal, oldVle) {
        //console.log(newVal)
        if (oldVle) {
          let arr = [];
          Object.keys(newVal).map((k, index, item) => {
            arr.push({
              name: newVal[k],
              type: k,
            });
          });
          this.chooseArr = arr;
          this.$emit("menusTabs", this.chooseArr);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    showMore(index) {
      this.isMore = !this.isMore;
      this.moreText = this.isMore ? "收起" : "更多";
    },
    selectTabs(index, pIndex, row) {
      let currentRow = document.getElementsByClassName("menus" + pIndex)[0];
      let lis = currentRow.childNodes;
      // let arr = []
      if (lis[index].className.length <= 0) {
        lis[index].className = "+activeMenu"; // 添加类
      } else {
        lis[index].className = ""; // 选中再取消的情况
      }
      for (let i = 0; i < lis.length; i++) {
        if (lis[i].className.length > 0) {
          this.$set(
            this.choose,
            row.type + "-" + pIndex + "-" + i,
            lis[i].innerText
          );
        } else {
          this.$delete(this.choose, row.type + "-" + pIndex + "-" + i);
        }
      }
      // Object.keys(this.choose).map((k, index, item) => {
      // 	arr.push({
      // 		name: this.choose[k],
      // 		type: k
      // 	})
      // })
      // this.chooseArr = arr
    },
    delSelected(row) {
      //let type = row.type.substring(0,row.type.indexOf('-'));
      let pIndex = row.type.substring(
        row.type.indexOf("-") + 1,
        row.type.lastIndexOf("-")
      );
      let key = row.type.slice(row.type.lastIndexOf("-") + 1);
      let currentRow = document.getElementsByClassName("menus" + pIndex)[0];
      let lis = currentRow.childNodes;
      this.$delete(this.choose, row.type);
      lis[key].className = "";
    },
    delAll() {
      this.choose = {};
      for (let i = 0; i < this.$refs.liId.length; i++) {
        if (this.$refs.liId[i].className.length > 0) {
          this.$refs.liId[i].className = "";
        }
      }
    },
  },
  mounted() {
    console.log(this.$route);
    if (this.$route.query.id) {
      this.selectTabs(this.$route.query.id - 1, 0, { type: "商标分类" });
    }
  },
};
</script>

<style lang="scss">
@include component(select-menus) {
  width: 100%;
  //min-height: 225px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  color: #333333;
  background: #fff;

  @include part(item) {
    width: 100%;
    border-bottom: 1px dashed #e2e2e2;
    padding-right: 18px;
    &:nth-last-child(1) {
      border-bottom: 0;
    }
  }

  @include part(tab) {
    display: flex;
    //justify-content: space-between;

    span {
      display: flex;
      width: 120px;
      min-height: 73px;
      text-align: center;
      line-height: 73px;
      border-right: 1px solid #e2e2e2;
      //align-items: center;
      justify-content: center;
    }

    button {
      width: 70px;
      height: 30px;
      border: 1px solid rgba(226, 226, 226, 1);
      margin-top: 20px;
      background: none;
      outline: none;
      position: relative;
      cursor: pointer;

      &:after {
        content: "";
        display: inline-block;
        width: 11px;
        height: 8px;
        background-image: url(../assets/down-nav.png);
        background-size: cover;
      }
    }

    ul {
      width: calc(100% - 190px);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      //padding: 10px 0;
      padding-left: 18px;
      height: 73px;
      overflow: hidden;

      li {
        padding: 0 18px;
        cursor: pointer;
        text-align: left;
        height: 73px;
        line-height: 73px;

        &:hover {
          color: #2278fc;
        }
      }

      &.menus0 {
        //padding-top: 18px;
        //padding-bottom: 18px;
      }
    }
  }

  @include part(more-menus) {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    background: #fff;

    ul {
      width: calc(100% - 119px);
      border-left: 1px solid #e2e2e2;
      padding-left: 68px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 18px;

      //background: red;
      li {
        margin-right: 18px;
      }
    }
  }

  @include part(selected) {
    width: 100%;
    display: flex;
    justify-content: flex-start;

    h3 {
      margin: 0;
      width: 120px;
      font-size: 18px;
      height: 53px;
      line-height: 53px;
	  margin-top: 12px;
    }

    div {
      width: calc(100% - 120px);
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: center;
      padding: 18px 0;
      padding-left: 18px;

      a {
        display: inline-block;
        // width: calc(100% / 6);
        padding: 0 10px;
        height: 40px;
        line-height: 40px;
        border: 1px solid rgba(226, 226, 226, 1);
        border-radius: 5px;
        color: #2278fc;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-right: 20px;
        margin-bottom: 10px;

        &:nth-child(6n) {
          margin-top: 10px;
        }

        &:nth-last-child(1) {
          border: 1px solid rgba(34, 120, 252, 1);
        }
        span {
          &:nth-of-type(1) {
            padding-right: 20px;
          }
        }

        img {
          display: block;
        }
      }
    }
  }

  @include tweak(moreIcon) {
    &:after {
      background-image: url(../assets/nav-up.png);
    }
  }

  @include tweak(activeMenu) {
    color: #2278fc;
  }
  @include tweak(moreHeight) {
    height: 450px;
    padding: 10px 0;
    padding-left: 15px;
    li {
      height: 40px;
      line-height: 40px;
    }
  }
  @include tweak(moreShortHeight) {
    height: 120px;
  }
}
</style>
